import { analytics } from '../config/firebase';
import { logEvent } from 'firebase/analytics';

export const trackEvent = (eventName: string, eventParams?: { [key: string]: any }) => {
  if (!analytics) {
    // Analytics not available (e.g., during prerender) - fail silently
    if (process.env.NODE_ENV !== 'production') {
      console.warn('[Analytics] Analytics instance is not available, skipping event:', eventName);
    }
    return;
  }

  if (process.env.NODE_ENV === 'production') { // Only track events in production
    logEvent(analytics, eventName, eventParams);
  } else {
    console.log(`[Analytics Event]: ${eventName}`, eventParams || '');
  }
};
